export const culture = {
    locale: "tr-TR",
    monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    dateFormat: 'dd.mm.yy',
    datePlaceholder: 'dd.mm.yyyy',
    weekHeader: 'Hf',
    firstDay: 1,
    monthDayFormat: 'dd.mm',
    shortFormat: "d M",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'HH:mm:ss',
    shortTimeFormat: 'HH:mm',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: '.',
    moneyWithCurrencyFormat: "{v} {c}",
    from: 'Gönderen',
    by: 'Ile',
    fromFormat: '{0} Gönderen',
    byFormat: '{0} ile'
};

export const datepicker = {
    ...culture,
    closeText: 'kapat',
    prevText: 'geri',
    nextText: 'ileri',
    currentText: 'bugün',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
